// src/components/LoadingSpinner.js
import React from 'react';
import './LoadingSpinner.css'; // Ensure you create appropriate styles

const LoadingSpinner = () => (
  <div className="loading-spinner">
    <div className="spinner" />
    <p>Loading...</p>
  </div>
);

export default LoadingSpinner;
